// Single source of truth for every outbound vendor URL on the site.
// To activate a pending program: set url, isAffiliate:true, live:true — nothing else changes.
export const AFFILIATE_LINKS = {
  phrasly: { url: "https://phrasly.ai/?via=aiwriting", isAffiliate: true, live: true },
  rytr: { url: "https://rytr.me/?via=mark-henry", isAffiliate: true, live: true },
  codexleo: { url: "https://www.checkout-ds24.com/redir/557220/grandson23/", isAffiliate: true, live: true },
  whatconverts: { url: "https://partners.whatconverts.com/vmmrhmz905yh", isAffiliate: true, live: true },
  dryground: { url: "https://partners.dryground.ai/oddgpp124qd8", isAffiliate: true, live: true },
};

export const getRel = (isAffiliate) => (isAffiliate ? "sponsored noopener noreferrer" : "noopener noreferrer");

// Resolves the entry that should actually be linked to for a given key.
// Live keys resolve to themselves; non-live keys resolve through their fallback.
export const resolveOutbound = (key) => {
  const entry = AFFILIATE_LINKS[key];
  if (!entry) return null;
  if (entry.live && entry.url) return { key, ...entry };
  if (entry.fallback && AFFILIATE_LINKS[entry.fallback]) {
    return { key: entry.fallback, ...AFFILIATE_LINKS[entry.fallback] };
  }
  return { key, ...entry };
};

// Returns { href, target, rel } ready to spread onto an <a>, or null if nothing resolves.
export const getOutboundProps = (key) => {
  const resolved = resolveOutbound(key);
  if (!resolved || !resolved.url) return null;
  return { href: resolved.url, target: "_blank", rel: getRel(resolved.isAffiliate) };
};

export const isLiveKey = (key) => {
  const resolved = resolveOutbound(key);
  return !!(resolved && resolved.key === key);
};
